import React from 'react';
import { LogoWithText } from '@sm/webassets/Logos';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { createURL } from '@sm/utils';
import { Grid } from '@wds/grid';
import { generateMetricsAttribute } from '@sm/metrics';
import { IconLogoGoldie } from '@wds/icons';

import { ShadedBackgroundColorProp } from '~app/components/EndpageImage';

import useStyles from './useStyles';
import { STANDARD_ENDPAGE_DEFAULT_COPY } from './copy';

type PollingHeaderProps = {
  logoRoute: string;
  utSource: string;
  utSource2: string;
  utSource3: string;
  amplitudeEventName: string;
  templateType: string;
  surveyId: string;
  collectorId: string;
  respondentId: string;
  shadedBackgroundColor: ShadedBackgroundColorProp;
};

export default function PollingHeader({
  logoRoute,
  utSource,
  utSource2,
  utSource3,
  amplitudeEventName,
  templateType,
  surveyId,
  collectorId,
  respondentId,
  shadedBackgroundColor,
}: PollingHeaderProps): React.ReactElement {
  const logoColor = shadedBackgroundColor?.startsWith('dark') ? 'alt' : 'primary';
  const { container, logoWithText, logoGoldie, logoGoldieContainer, logoWithTextContainer } = useStyles({
    shadedBackgroundColor,
  });

  return (
    <>
      <Box className={`${container} ${logoWithTextContainer}`} display="flex" flexDirection="column" pt={6} pb={5}>
        <Grid>
          <Grid.Item>
            <a
              aria-label={t(STANDARD_ENDPAGE_DEFAULT_COPY.LOGO_ARIA_LABEL)}
              data-testid="PollingHeader__LogoWithText"
              href={createURL(logoRoute, {
                ut_source: utSource,
                ut_source2: utSource2,
                ut_source3: utSource3,
                ut_ctatext: 'LogoWithText',
              })}
              data-sm-metrics={generateMetricsAttribute({
                data: {
                  amplitudeEvent: amplitudeEventName,
                  itemSelected: 'logo',
                  templateType,
                  surveyId,
                  collectorId,
                  respondentId,
                  log: {
                    message: `${utSource}-${utSource2}-${utSource3}-LogoWithText`,
                  },
                },
              })}
            >
              <LogoWithText className={logoWithText} color={logoColor} />
            </a>
          </Grid.Item>
        </Grid>
      </Box>
      <Box
        className={`${container} ${logoGoldieContainer}`}
        display="flex"
        flexAlign="center"
        flexDirection="column"
        pt={6}
      >
        <a
          className={logoGoldie}
          aria-label={t(STANDARD_ENDPAGE_DEFAULT_COPY.LOGO_ARIA_LABEL)}
          data-testid="PollingHeader__LogoWithText"
          href={createURL(logoRoute, {
            ut_source: utSource,
            ut_source2: utSource2,
            ut_source3: utSource3,
            ut_ctatext: 'Goldie',
          })}
          data-sm-metrics={generateMetricsAttribute({
            data: {
              amplitudeEvent: amplitudeEventName,
              itemSelected: 'logo',
              templateType,
              surveyId,
              collectorId,
              respondentId,
              log: {
                message: `${utSource}-${utSource2}-${utSource3}-LogoWithText`,
              },
            },
          })}
        >
          <IconLogoGoldie title="goldie" color="primary" />
        </a>
      </Box>
    </>
  );
}
